export const PROJECT_NAME = 'modes'
